export const trackersPiwik = {
  loaded: false,
  enabled: false,

  // Load Piwik and begin tracking.
  // Note, if your juristiction requires prior consent before tracking technologies are used,
  // then you should have obtained consent BEFORE you call this method!
  load: function(domains, url, siteId) {
    if (!this.loaded) {
      console.log("Loading scripts and enabling Piwik");

      // See https://developer.matomo.org/guides/tracking-javascript-guide
      // and https://developer.matomo.org/guides/tracking-javascript-guide#asking-for-consent
      if (typeof _paq === 'undefined') {
        _paq = [];
      }
      _paq.push(['requireConsent']);
      _paq.push(['setConsentGiven']);
      _paq.push(["setDomains", domains]);
      _paq.push(['trackPageView']);
      _paq.push(['enableLinkTracking']);
      (function() {
        var u=url;
        _paq.push(['setTrackerUrl', u+'/piwik.php']);
        _paq.push(['setSiteId', siteId]);
        var d=document, g=d.createElement('script'), s=d.getElementsByTagName('script')[0];
        g.type='text/javascript'; g.async=true; g.defer=true; g.src=u+'piwik.js'; s.parentNode.insertBefore(g,s);
      })();

      this.loaded = true;
      this.enabled = true;
    } else {
      console.log("Piwik scripts already loaded - re-enabling");
      _paq.push(['setConsentGiven']);
      this.enabled = true;
    }
  },

  // Revoke consent for this user to be tracked by Piwik
  // See https://developer.matomo.org/guides/tracking-javascript-guide#step-4-user-removes-consent
  revokeConsent: function() {
    console.log("Disabling Piwik");
    _paq.push(['forgetConsentGiven']);
    this.enabled = false;
  }
};
